import Vue from 'vue'

const ENDPOINT = '/contact_types'

export default {
  get () {
    return Vue.prototype.$http.get(`${ENDPOINT}`).then(response => response.data)
  }
}
